import { AppRoutes } from '../app/constants'

/** Profile option ID of the private profile, next to company member IDs */
export const PrivateProfileId = 'private'

/** From this many company profiles, the profile pickers get a search field */
export const MinCompaniesForSearch = 6

/** Query param that opens the new order panel on the company overview */
export const NewOrderQueryParam = 'newOrder'

/** Where the company entry points in the navbar, banner and menus lead */
export const CompanyRoutes = {
  /** The company overview: calendar and upcoming orders */
  Overview: AppRoutes.CompanyOverview,
  /** Read-only company and invoicing details */
  Details: AppRoutes.CompanyDetails,
  /** The overview, opening the new order panel */
  NewOrder: `${AppRoutes.CompanyOverview}?${NewOrderQueryParam}=1`,
}
